import {MenuSections} from './types';
import {LocaleEnum} from '../../../types/locale';

export const LOGIN_TEST_ID = 'nav-login';

const deAtLinks: MenuSections = {
  logoUrl: '/at/',
  other: [
    {
      href: '/at/kontakt/',
      label: 'Kontakt',
      dataTestId: 'nav-kontakt'
    },
    {
      href: 'https://checkout.ready2order.com/shop/at',
      label: 'Shop',
      dataTestId: 'nav-shop'
    },
    {
      href: '/at/login/',
      label: 'Login',
      dataTestId: LOGIN_TEST_ID
    }
  ]
};

const deChLinks: MenuSections = {
  logoUrl: '/ch/',
  other: [
    {
      href: '/ch/kontakt/',
      label: 'Kontakt',
      dataTestId: 'nav-kontakt'
    },
    {
      href: 'https://checkout.ready2order.com/shop/ch',
      label: 'Shop',
      dataTestId: 'nav-shop'
    },
    {
      href: '/ch/login/',
      label: 'Login',
      dataTestId: LOGIN_TEST_ID
    }
  ]
};

const deDeLinks: MenuSections = {
  logoUrl: '/de/',
  other: [
    {
      href: '/de/kontakt/',
      label: 'Kontakt',
      dataTestId: 'nav-kontakt'
    },
    {
      href: 'https://checkout.ready2order.com/shop/de',
      label: 'Shop',
      dataTestId: 'nav-shop'
    },
    {
      href: '/de/login/',
      label: 'Login',
      dataTestId: LOGIN_TEST_ID
    }
  ]
};

const enUsLinks: MenuSections = {
  logoUrl: '/en/',
  other: [
    {
      href: '/en/contact/',
      label: 'Contact us',
      dataTestId: 'nav-contact'
    },
    {
      href: '/en/login/',
      label: 'Login',
      dataTestId: LOGIN_TEST_ID
    }
  ]
};

const enIELinks: MenuSections = {
  logoUrl: '/ie/',
  other: [
    {
      href: '/ie/contact/',
      label: 'Contact us',
      dataTestId: 'nav-contact'
    },
    {
      href: '/ie/login/',
      label: 'Login',
      dataTestId: LOGIN_TEST_ID
    }
  ]
};

export const allLocaleLinks = new Map<LocaleEnum, MenuSections>([
  [LocaleEnum.AT, deAtLinks],
  [LocaleEnum.CH, deChLinks],
  [LocaleEnum.DE, deDeLinks],
  [LocaleEnum.EN, enUsLinks],
  [LocaleEnum.IE, enIELinks]
]);
